<script setup lang="ts">
const app = useNuxtApp()
const route = useRoute()
const storeIndex = useStoreIndex()
const storeArticleDetail = useStoreArticleDetail()

definePageMeta({
  layout: 'layout-side-default',
  validate: async (route) => {
    const app = useNuxtApp()
    if (route.name === 'preview-static-id') {
      return app.$anyToInteger(route.params.id, null) ? true : false
    }
    return true
  },
})

const pageData = { item: null as any }

const setHead = () => {
  const headTitle = pageData.item?.title
  // ぱんくず作成
  storeIndex.setBreadCrumbs([
    {
      text: headTitle,
      disabled: true,
    },
  ])

  const headInput = app.$makeMeta({ title: headTitle })
  useHead(headInput)
}

const initPage = async () => {
  const options = {
    fetchParams: {
      articleTypeSlug: 'static',
      articleSlugOrId: null,
    },
    isNoSetHead: true,
  }
  if (route.name === 'preview-static-id') {
    options.fetchParams.articleSlugOrId = app.$anyToInteger(route.params.id)
  } else {
    options.fetchParams.articleSlugOrId = route.params.slug
  }

  const [_resSite, _resMaster, res] = await Promise.all([
    storeIndex.fetchSite(),
    storeIndex.fetchMaster(),
    storeArticleDetail.fetchDetail(options),
  ])
  if (res.code !== 200000) {
    //  表示できない
    throw createError({ statusCode: 404 })
    return
  } else {
    pageData.item = res.data.article
  }
}
await initPage()
setHead()

onMounted(() => {
  //  検定だけ、ハードコード
  if (route.params.slug === '567') {
    const scriptStart = document.createElement('script')
    const src = 'kaisi();'
    scriptStart.appendChild(document.createTextNode(src))
    document.head.appendChild(scriptStart)
  }
})
</script>

<template>
  <div class="p-main">
    <StaticBody
      v-bind:item="pageData.item"
    />
  </div>
</template>
